import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";

import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";
import { asPartner, listResults } from "../lib/thirdDoorAdapters";

export default function StrategicPartners() {
  const { resources } = useModelIndex("strategic_partner" as any, { limit: 25 } as any);
  const partners = listResults(resources).map(asPartner);
  return (
    <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full space-y-6">
      <Card className="border-primary/20 shadow-sm">
      <CardHeader>
      <Badge className="w-fit">Strategic Partners</Badge>
      <CardTitle className="text-2xl">Collaborative nodes supporting capability growth and adoption</CardTitle>
      <CardDescription>Explore partner organizations across innovation, procurement, and operational adoption.</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-3">
      <Button asChild><Link to="/opportunities">View Opportunities</Link></Button>
      <Button asChild variant="outline"><Link to="/contact">Contact Team</Link></Button>
      </CardContent>
      </Card>

      <div className="grid gap-4 md:grid-cols-2">
      {partners.map((partner) => (
      <Card key={partner.name} className="border-border shadow-sm">
      <CardHeader>
      <CardTitle className="text-lg">{partner.name}</CardTitle>
      <CardDescription>{partner.focus}</CardDescription>
      </CardHeader>
      <CardContent>
      <Badge variant="secondary">{partner.type}</Badge>
      </CardContent>
      </Card>
      ))}
      </div>
      </section>
      </div>
    </div>
  );
}